'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchBar = require('./components/SearchBar');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SearchBar).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/material-ui-search-bar/lib/index.js
// module id = 459
// module chunks = 0